import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// import Chat from "@material-ui/icons/Chat";
// import VerifiedUser from "@material-ui/icons/VerifiedUser";
// import Fingerprint from "@material-ui/icons/Fingerprint";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import proPlan from "assets/Project Plan.png"
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import Button from "components/CustomButtons/Button.js";
import {Link} from 'react-router-dom'
const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
 
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Let{"'"}s talk about the Project</h2>
          <h5 className={classes.description}>
          We aim to build a prototype brain-controlled smart wheelchair with many features to help people who cannot use their muscles to move to be able to move wherever they want more easily and safely. 
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer >

          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="Importance of the problem"
              description="Our project targets people who suffer from mobility impairment and are in constant need of using wheelchairs. These are about 1% of the world’s population (around 780 million people). Our project also targets people who require using wheelchairs but are unable to use them because they cannot use their arms to control the wheelchair (ex: ALS patients).
              "
            />
          </GridItem>


          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="Normal current solutions"
              description="Current solutions include ordinary wheelchairs, which are hard or impossible to use for some patients, and classical electrical wheelchairs which use a joystick that helps them move more easily. The problem with the latter is that it does not help patients who cannot use their arms. Also, it can get extremely painful on the hand with excessive use.
              "
            />
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="Our Solution to solve the problem by new idea"
              description="We Use Brain-Computer Interfaces (BCIs) is one of the best solutions to this problem, as the user does not need to move any muscle at all to be able to operate the chair. The user can only think about moving (or in our case, look at a button on a screen) and the chair will move on its own by analyzing the recorded Electroencephalography (EEG) signals. Additionally, the wheelchair will have computer vision capabilities that allow it to take smart actions such as avoiding collisions and autonomous following of predefined routes to ensure the safety and comfort of the user."
            />
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="Impact Of The Project"
              description="If our project started going into production, it will allow more people to safely move and explore their environment. It will be able to change the lives of many people from just being stuck in one room, to being able to move freely not only in their own homes but also in the streets. Furthermore, we plan to publish a scientific paper at the end of our project so we can help the scientific community. We will also publish our work as an open-source project on GitHub with all our code to make it easier for anyone to recreate our project relatively easily if needed.
              "
            />
          </GridItem>


          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="High-level description of project behavior"
              description={<p>Using the wheelchair should be very simple but effective. The user’s guardian should help them sit on the wheelchair, attach the safety belt, and wear the brain recording headset. The user is then free to choose between two modes of operations:
                <br/>
                <span><b>&#160;Manual mode</b><br/>
                <p>
                The user can move the chair as they please. They control the chair by looking at a flashing button on a screen as shown in the figure below. Different buttons correspond to different instructions. Basic instructions would include moving forward, rotating the chair (clockwise or anticlockwise), and stopping. 
                </p>
                </span>

                <span><b>&#160;Autonomous mode</b><br/>
                <p>
                The system will also include the option to select predefined locations so that the chair will be able to move to those locations autonomously using the Global Positioning System (GPS) and computer vision.  
                </p>
                </span>
                
                <p>
                <b>Additionally,</b> some emergency protocols are present to ensure the safety of the user, including autonomously sending emergency messages to the caretaker’s mobile phone in case of emergency or on-demand.
                <br/>
                The user may have other quality of life features to help them interact with their environment more easily (ex: controlling lights, doors, etc.).

                </p>


              </p>}
            />
          </GridItem>


          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="high-level technical description of our project"
              description={
              <>
              <p>We use a brain-computer interface (BCI) for an electric wheelchair using an Electroencephalography (EEG) headset by reading Steady-state visually evoked potential (SSVEP) signals in response to the flashing buttons that the user is looking at. The wheelchair will also have cameras that utilize multiple computer vision systems for obstacle detection to avoid collisions or moving into rough terrain or damaging the wheelchair and injuring the user. It will also have an autonomous mode using GPS which will help the user move to their target location in autopilot with minimal effort.
                <br/>
                <br/>
                <b>below, Initial architecture of the project showing its main components, how they may interact with each other and how its achieve non-monolithic components(loose coupling)</b>
                <br/>
                </p>
                <img src={proPlan} alt='...' style={{
                  width:'100%'
                }}/>
                </>
                }
            />
          </GridItem>


          <GridItem xs={12} sm={12} md={12}>
            <InfoArea
              title="Project Plan and TimeLine"
              description={
              <>
              <p>At the beginning of the semester, we created a rough schedule and training plan. The proposed schedule is shown in the figure below. We split into 3 sub-teams, (BCI, Computer Vision, Embedded) and try to work on all three aspects in parallel in the first semester. The main idea here is to learn all required knowledge before starting the semester and finish implementing every part independently by the end of the first semester. After the final exams for our first semester, we will start studying topics on how we can use these models on microcontrollers and make those microcontrollers work together for the final project to work. We should be done with our learning phase by the start of the second semester, where we will start working on implementation and integration during the second semester. We also plan to write the research paper mentioned by the end of the second semester before our finals. Finally, we have an extra month after our finals before the project deadlines as backup and to optimize any part that needs further optimization.If our project started going into production, it will allow more people to safely move and explore their environment. It will be able to change the lives of many people from just being stuck in one room, to being able to move freely not only in their own homes but also in the streets. Furthermore, we plan to publish a scientific paper at the end of our project so we can help the scientific community. We will also publish our work as an open-source project on GitHub with all our code to make it easier for anyone to recreate our project relatively easily if needed.
              </p>
              <br/>
              <Button
                component={Link}
                variant="outlined" 
                color="secondary"
                size="lg"
                to='/TimeLine'
                rel="noopener noreferrer"
              >
                Time Line Chart
              </Button>
              </>}
            />
          </GridItem>



          
         
        </GridContainer>
      </div>
    </div>
  );
}
